module.exports = __webpack_public_path__ + "static/img/services12.b4ee978.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/services12.png
// module id = YqRo
// module chunks = 0